<div class="space-y-4">
  <div class="flex items-center justify-between">
    <h3 class="text-sm font-semibold text-gray-700 dark:text-gray-300 uppercase tracking-wide">Precios por Moneda</h3>
    @if (!showForm) {
    <button type="button" (click)="abrirForm()"
      class="px-2.5 py-1 text-xs rounded-md font-medium bg-brand-500 text-white hover:bg-brand-600 flex items-center gap-1">
      <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"></path>
      </svg>
      Agregar
    </button>
    }
  </div>

  @if (error) {
  <div class="p-3 bg-error-50 border border-error-200 rounded-lg dark:bg-error-900/20 dark:border-error-800">
    <p class="text-sm text-error-600 dark:text-error-400">{{ error }}</p>
  </div>
  }

  <!-- Formulario inline -->
  @if (showForm) {
  <div class="border border-brand-200 dark:border-brand-800/40 rounded-lg p-3 bg-brand-50/40 dark:bg-brand-900/10 space-y-2">
    <div class="flex items-center justify-between">
      <span class="text-xs font-semibold text-brand-600 dark:text-brand-400">Nuevo precio por moneda</span>
      <button type="button" (click)="cerrarForm()" class="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
        </svg>
      </button>
    </div>
    <div class="grid grid-cols-1 sm:grid-cols-3 gap-2">
      <div>
        <label class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-0.5">Moneda <span class="text-error-500">*</span></label>
        <select [(ngModel)]="formCurrencyId"
          class="w-full px-2.5 py-1.5 text-xs border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent">
          <option [ngValue]="null">Seleccionar...</option>
          @for (c of currencies; track c.id) {
            <option [ngValue]="c.id">{{ c.name }} ({{ c.code }})</option>
          }
        </select>
      </div>
      <div>
        <label class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-0.5">Tipo de precio</label>
        <select [(ngModel)]="formPriceType"
          class="w-full px-2.5 py-1.5 text-xs border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent">
          <option value="fixed">Fijo</option>
          <option value="calculated">Calculado</option>
        </select>
      </div>
      @if (formPriceType === 'fixed') {
      <div>
        <label class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-0.5">Precio fijo</label>
        <input type="number" [(ngModel)]="formFixedPrice" min="0" step="0.01" placeholder="0.00"
          class="w-full px-2.5 py-1.5 text-xs border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent" />
      </div>
      }
    </div>
    <div class="flex items-center justify-end gap-2 pt-1">
      <button type="button" (click)="cerrarForm()"
        class="px-2.5 py-1 text-xs rounded-md font-medium bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600">Cancelar</button>
      <button type="button" (click)="guardar()" [disabled]="saving || !formCurrencyId"
        class="px-2.5 py-1 text-xs rounded-md font-medium bg-brand-500 text-white hover:bg-brand-600 disabled:opacity-50 disabled:cursor-not-allowed">
        {{ saving ? 'Guardando...' : 'Guardar' }}
      </button>
    </div>
  </div>
  }

  @if (loading) {
  <div class="flex items-center gap-2 text-gray-500 dark:text-gray-400 py-4">
    <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-brand-500"></div>
    <span class="text-sm">Cargando...</span>
  </div>
  } @else if (priceCurrencies.length === 0 && !showForm) {
  <p class="text-sm text-gray-500 dark:text-gray-400 py-4 text-center">No hay precios por moneda configurados.</p>
  } @else {
  <div class="overflow-x-auto">
    <table class="min-w-full text-xs">
      <thead>
        <tr class="border-b border-gray-200 dark:border-gray-700">
          <th class="px-3 py-2 text-left font-medium text-gray-500 dark:text-gray-400">Moneda</th>
          <th class="px-3 py-2 text-left font-medium text-gray-500 dark:text-gray-400">Tipo</th>
          <th class="px-3 py-2 text-right font-medium text-gray-500 dark:text-gray-400">Precio fijo</th>
          <th class="px-3 py-2 text-right font-medium text-gray-500 dark:text-gray-400">Precio resuelto</th>
          <th class="px-3 py-2"></th>
        </tr>
      </thead>
      <tbody class="divide-y divide-gray-100 dark:divide-gray-700/50">
        @for (pc of priceCurrencies; track pc.id) {
        <tr>
          <td class="px-3 py-2 text-gray-800 dark:text-white">{{ pc.currencyName || getCurrencyName(pc.currencyId) }} <span class="text-gray-500">({{ pc.currencyCode }})</span></td>
          <td class="px-3 py-2 text-gray-600 dark:text-gray-400">{{ pc.priceType === 'fixed' ? 'Fijo' : 'Calculado' }}</td>
          <td class="px-3 py-2 text-right text-gray-800 dark:text-white">{{ formatPrecio(pc.fixedPrice, pc.currencySymbol, pc.currencyCode) }}</td>
          <td class="px-3 py-2 text-right font-semibold text-brand-600 dark:text-brand-400">
            @if (pc.priceType === 'calculated' && (pc.usdValueUsed === null || pc.usdValueUsed === undefined)) {
              <!-- Inc 37: el badge se mantiene, pero acompañado de la acción para resolverlo -->
              <div class="flex flex-col items-end gap-0.5">
                <span class="text-warning-600 dark:text-warning-400 font-medium" title="La moneda no tiene tipo de cambio configurado">Sin tasa</span>
                <a routerLink="/productos/tipos-cambio"
                  class="text-[11px] font-medium text-brand-600 hover:underline dark:text-brand-400">Configurar tipo de cambio</a>
              </div>
            } @else {
              {{ formatPrecio(pc.resolvedPrice, pc.currencySymbol, pc.currencyCode) }}
            }
          </td>
          <td class="px-3 py-2">
            <button type="button" (click)="eliminar(pc.currencyId)"
              class="rounded p-1 hover:bg-error-50 hover:text-error-600 text-gray-400" title="Eliminar">
              <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path>
              </svg>
            </button>
          </td>
        </tr>
        }
      </tbody>
    </table>
  </div>
  }

  <!-- Widget resolver -->
  <div class="pt-4 border-t border-gray-200 dark:border-gray-700">
    <h4 class="text-xs font-semibold text-gray-600 dark:text-gray-400 uppercase tracking-wide mb-2">Resolver precio por moneda</h4>
    <div class="flex items-center gap-3">
      <select [(ngModel)]="resolveCurrencyId" (ngModelChange)="onResolveCurrencyChange()"
        class="w-48 px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent">
        <option [ngValue]="null">Seleccionar moneda...</option>
        @for (c of currencies; track c.id) {
          <option [ngValue]="c.id">{{ c.name }} ({{ c.code }})</option>
        }
      </select>
      <button type="button" (click)="resolver()" [disabled]="resolving || !resolveCurrencyId"
        class="px-3 py-1.5 text-sm rounded-lg font-medium bg-brand-500 text-white hover:bg-brand-600 disabled:opacity-50 disabled:cursor-not-allowed">
        {{ resolving ? 'Resolviendo...' : 'Resolver' }}
      </button>
      @if (resolveResult !== null) {
      <div class="px-3 py-1.5 bg-brand-50 dark:bg-brand-900/20 rounded-lg">
        <span class="text-xs text-gray-500 dark:text-gray-400 mr-2">Precio resuelto:</span>
        <span class="text-sm font-bold text-brand-600 dark:text-brand-400">{{ formatPrecio(resolveResult, resolveSymbol, resolveCode) }}</span>
      </div>
      } @else if (resolveError) {
      <!-- Inc 37: mensaje del backend (nombra la moneda) + enlace directo a Tipos de Cambio -->
      <div class="px-3 py-1.5 bg-warning-50 dark:bg-warning-500/10 rounded-lg flex items-start gap-1.5">
        <svg class="w-4 h-4 text-warning-500 shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M12 9v2m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
        </svg>
        <div>
          <span class="text-sm font-medium text-warning-700 dark:text-warning-400">{{ resolveError }}</span>
          <a routerLink="/productos/tipos-cambio"
            class="ml-1 text-sm font-semibold text-brand-600 hover:underline dark:text-brand-400">Ir a Tipos de Cambio</a>
        </div>
      </div>
      }
    </div>
  </div>
</div>
